var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96998 4.88006L9.92298 8.69106C9.15898 8.87806 8.13998 9.00006 6.99998 9.00006C5.85998 9.00006 4.84198 8.87806 4.07698 8.69106L5.02998 4.88006C5.63498 4.95706 6.29998 5.00006 6.99998 5.00006C7.69998 5.00006 8.36498 4.95706 8.96998 4.88006ZM8.72498 3.90206L7.96998 0.880059C7.71798 -0.129941 6.28198 -0.129941 6.02998 0.880059L5.27498 3.90006C5.79998 3.96506 6.38198 4.00006 6.99998 4.00006C7.61798 4.00006 8.19998 3.96406 8.72498 3.90206ZM13.121 12.5151C13.2262 12.5411 13.3201 12.6007 13.3886 12.6847C13.457 12.7688 13.4963 12.8728 13.5004 12.9811C13.5046 13.0895 13.4735 13.1962 13.4117 13.2853C13.3499 13.3744 13.2609 13.441 13.158 13.4751L7.15798 15.4751C7.05541 15.5092 6.94454 15.5092 6.84198 15.4751L0.841976 13.4751C0.739067 13.441 0.65002 13.3744 0.588252 13.2853C0.526484 13.1962 0.495342 13.0895 0.499517 12.9811C0.503692 12.8728 0.542958 12.7688 0.6114 12.6847C0.679841 12.6007 0.77375 12.5411 0.878976 12.5151L3.26998 11.9171L3.83498 9.66006C4.69698 9.87206 5.79898 9.99906 6.99998 9.99906C8.20098 9.99906 9.30298 9.87206 10.165 9.66006L10.73 11.9171L13.121 12.5151Z",
    fill: "#FF4D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadwork);
export default __webpack_public_path__ + "static/media/roadwork.a4f7a2a9383f44687269b86363a9457a.svg";
export { ForwardRef as ReactComponent };